export default __webpack_public_path__ + "static/media/studio-zerance.37aca0de.png";